<template>
    <div class="mobile-filters">
      <hp5-button-decorator type="secondary" size="md">
        <button id="toggle" type="button" @click="active = !active">
          <hp5-icon name="system-filter" size="sm" />
          Filter results
        </button>
      </hp5-button-decorator>
      <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
      <div :class="'slider ' + (active ? 'opened' : 'closed')">
        <div class="filter-container">
            <FilterGroup :aria-hidden="!active" />
        </div>
        <!--see results button place at the bottom on filter panel to close the filter section-->
        <section class="bottom-section">
          <hp5-button-decorator type="primary" size="md" v-if="active">
            <button id="toggle" type="button" @click="active = !active">See results</button>
          </hp5-button-decorator>
        </section>
      </div>
    </div>
</template>

<script setup>
      const active = ref(false)
</script>
  
<style scoped lang="scss">
@use '~/assets/scss/breakpoints' as *;
  .mobile-filters {
    display: block;
  
    #toggle {
      width: 100%;
    }
  
    .filter-headers {
      padding-left: 12px;
    }
    .slider {
      overflow-y: scroll;
      height: 100%;
  
      transition: transform 0.3s ease;
  
      .filter-container {
        position: absolute;
        width: 100%;
        bottom: 100px;
        top: 0;
        overflow-y: auto;
        transition: all 0.5s ease;
        display: block;
      }
      .bottom-section {
        bottom: 0;
        position: absolute;
        border-top: 1px solid var(--color-neutral-light);
        padding-bottom: var(--spacing-md);
        padding-top: var(--spacing-md);
        width: 100%;
        z-index: 11;
      }
    }
  
    .slider.opened {
      /* visible */
      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      width: 100%;
      background-color: #fff;
      z-index: 10;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: var(--color-background-base);
      z-index: 10;
      -webkit-transform: translate(0, 0%);
      -moz-transform: translate(0, 0%);
      -ms-transform: translate(0, 0%);
      transform: translate(0, 0%);
    }
    .slider.closed {
      /* completely offscreen */
      -webkit-transform: translate(-100%, 0);
      -moz-transform: translate(0, -100%);
      -ms-transform: translate(0, -100%);
      transform: translate(-105%, 0%);
    }
  }
  
  </style>